import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class OidcToolService {
  public get oauth(): OAuthService {
    return this.oauthService;
  }
  public config() {
    this.oauthService.configure({
      issuer: environment.oidc.issuer,
      redirectUri: window.location.origin + '/auth/verify',
      postLogoutRedirectUri: window.location.origin + '/',
      silentRefreshRedirectUri: window.location.origin,
      clientId: 'roi',
      responseType: 'code',
      scope:
        'openid profile offline_access GatewayProject.PresentationAPI SSOProject.PresentationAPI',

      showDebugInformation: environment.production ? false : true,
    });
  }
  constructor(private oauthService: OAuthService) {}
}
